module.exports = __webpack_public_path__ + "img/table2.6e68ed6c.png";